import React from "react";
import PropTypes from "prop-types";

import { useBooleanState } from "hooks";

import { DefaultCard, HoveredCard } from "./components";

const statusToButtonText = {
  ALLOWED: "Add to Hub",
  CAN_REQUEST: "Request Access",
  REQUESTED: "Access Requested",
  ALREADY_INSTALLED: "Installed",
  DENIED: "Access Denied",
  PUBLISHED: "Published",
};

export function TemplateCard({ template, disabled }) {
  const [isHovered, hovered, notHovered] = useBooleanState();

  if (isHovered || template.installing) {
    const { installableStatus } = template;
    const hasAccess =
      installableStatus === "ALLOWED" || Boolean(template.installed);
    const onClickFunc = hasAccess ? template.install : template.request;
    return (
      <HoveredCard
        buttonText={statusToButtonText[installableStatus]}
        onMouseLeave={notHovered}
        onClick={onClickFunc}
        loading={template.installing}
        disabled={
          disabled ||
          !(
            installableStatus === "CAN_REQUEST" ||
            installableStatus === "ALLOWED"
          )
        }
      >
        {template.current?.about}
      </HoveredCard>
    );
  }

  return (
    <DefaultCard
      onMouseEnter={hovered}
      onMouseLeave={notHovered}
      title={template.current.title}
      numWorkflows={template.current?.numWorkflows}
      publishingName={template.publishingName}
      faviconUrl={template.faviconUrl}
    />
  );
}

TemplateCard.propTypes = {
  disabled: PropTypes.bool,
  template: PropTypes.shape({
    current: PropTypes.shape({
      title: PropTypes.string.isRequired,
      about: PropTypes.string,
      numWorkflows: PropTypes.number,
    }).isRequired,
    installed: PropTypes.object,
    installing: PropTypes.bool,
    install: PropTypes.func.isRequired,
    request: PropTypes.func.isRequired,
    publishingName: PropTypes.string.isRequired,
    faviconUrl: PropTypes.string.isRequired,
    installableStatus: PropTypes.string.isRequired,
  }).isRequired,
};

TemplateCard.defaultProps = {
  disabled: false,
};

export default TemplateCard;
